import apiClient from "../config/apiClient";

export const findSiglePatient = async (id) => {
  const user = window.localStorage.getItem("token");
  const token = user;
  return await apiClient.get(`/public/portal?url=patient/find?id=${id}`, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

// 27503


